function clickShopItem(list, items, label, isShop) {

  const areaList = document.querySelector(list)
  if(!areaList) return;
  const areaListItems = areaList.querySelectorAll(items)
  const areaLabel = areaList.querySelector(label)
  const isShopItems = document.querySelectorAll(isShop)

  let areaLabelImg = areaLabel.querySelector('img')

  areaListItems.forEach(li => {
    li.addEventListener('click', (/** @type {Event} */ e) => {
      // const areaKey = areaMap[li.textContent];
      areaListItems.forEach(li => li.classList.remove('active'))
      li.classList.add('active')
      //ラベル画像のsrcとaltを変更
      if (e.currentTarget.dataset.area === li.textContent) {
        areaLabelImg.src = e.currentTarget.dataset.titleSrc;
        areaLabelImg.alt = e.currentTarget.dataset.area + 'エリア';
      } else {
        console.error('指定されたエリアが見つかりません:', li.textContent);
      }
      //エリアに応じて表示する店舗を切り替える
      isShopItems.forEach(item => item.style.display = 'none')
      isShopItems.forEach(item => {
        if(item.dataset.area === li.textContent) {
          item.style.display = '';
        }
      })
    })
  })
  areaListItems[0].click();
}

// export {
//   clickShopItem,
// };

document.addEventListener('DOMContentLoaded', () => {
  clickShopItem('.shopAreaList', '.area__item', '.areaLabel', '.js-isShop');
  // clickShopItem('.js-list', '.area__item', '.areaLabel', '.js-isShop');
  clickShopItem('.gokainAreaList', '.area__item', '.areaLabel', '.js-isShop');
});
